// Projected-winner banner — view event. Fires once per banner mount when an
// outcome is projected to cross the resolution threshold (see spec 102).
// Distinct from `market_detail_viewed` so the funnel can attribute the
// "projected to win" surface separately. Re-fires on re-entry (unmount →
// re-mount when the projection flips off then on) so each entry contributes
// a single attribution event.

import type { EventDefinition } from './navigation';

// Use `type` (not `interface`) so the payload satisfies the
// `Record<string, unknown>` constraint that `EventDefinition` enforces —
// same convention as every other event payload in `src/events/`.
export type MarketApproachingResolutionViewedProperties = {
  marketPubkey: string;
  /** Outcome projected to win. */
  outcomeIndex: number;
  /** Seconds until the projected resolution when the banner mounted (0 when already due). */
  secondsToResolve: number;
};

export const MARKET_APPROACHING_RESOLUTION_VIEWED: EventDefinition<MarketApproachingResolutionViewedProperties> =
  {
    name: 'market_approaching_resolution_viewed',
  };
